import { AuthenticationReason } from '@mc-alberta/types';
/**
 * Converts a DAS `FidoAuthenticator` to a MACS `MfaMethod`.
 */
export function fidoAuthenticatorToMfaMethod({ authenticator: { type, assertionData, authenticatorInstanceReference, fidoAuthenticatorData }, authenticatorDeviceBindingAssessment, authenticatorLocation }, externalAuthMethodId) {
    return {
        mfaMethod: {
            type,
            assertionData: Object.assign(Object.assign({}, assertionData), { publicKeyCredentials: undefined }),
            externalAuthMethodId,
            certifiedMfaMethodId: authenticatorInstanceReference.certifiedMfaMethodId,
            externalMfaMethodInstanceId: authenticatorInstanceReference.dasAuthenticatorInstanceId,
            fidoMfaMethodData: {
                relyingPartyInfo: {
                    name: fidoAuthenticatorData.relyingParty
                },
                fidoUserName: fidoAuthenticatorData.fidoUserName,
                fidoDisplayName: fidoAuthenticatorData.fidoDisplayName,
                fidoUserId: fidoAuthenticatorData.fidoUserId,
                isSpcEnabled: fidoAuthenticatorData.spcEnabled
            }
        },
        authenticatorDeviceBindingAssessment,
        authenticatorLocation
    };
}
/**
 * Converts a MACS `MfaMethod` to a DAS `FidoAuthenticator`.
 */
export function mfaMethodToFidoAuthenticator({ mfaMethod, authenticatorDeviceBindingAssessment, authenticatorLocation }) {
    return {
        authenticator: {
            id: mfaMethod.externalAuthMethodId,
            type: 'FIDO2',
            authenticatorInstanceReference: {
                certifiedMfaMethodId: mfaMethod.certifiedMfaMethodId,
                dasAuthenticatorInstanceId: mfaMethod.externalMfaMethodInstanceId
            },
            fidoAuthenticatorData: {
                relyingParty: mfaMethod.fidoMfaMethodData.relyingPartyInfo.name,
                fidoUserName: mfaMethod.fidoMfaMethodData.fidoUserName,
                fidoDisplayName: mfaMethod.fidoMfaMethodData.fidoDisplayName,
                fidoUserId: mfaMethod.fidoMfaMethodData.fidoUserId,
                spcEnabled: mfaMethod.fidoMfaMethodData.isSpcEnabled
            },
            assertionData: mfaMethod.assertionData
        },
        authenticatorDeviceBindingAssessment,
        authenticatorLocation
    };
}
/**
 * Returns the DAS authentication context from the given MACS one.
 */
export function getAuthenticationContext({ authenticationReasons, dpaTransactionOptions, merchantName }) {
    return {
        authenticationReasons: authenticationReasons[0] === AuthenticationReason.ENROL_FINANCIAL_INSTRUMENT
            ? ['ENROLL_FINANCIAL_INSTRUMENT']
            : [authenticationReasons[0]],
        transactionAmount: dpaTransactionOptions === null || dpaTransactionOptions === void 0 ? void 0 : dpaTransactionOptions.transactionAmount,
        merchantName: (dpaTransactionOptions === null || dpaTransactionOptions === void 0 ? void 0 : dpaTransactionOptions.merchantName) || merchantName,
        supportedMethods: ['FIDO2']
    };
}
//# sourceMappingURL=transforms.js.map